@if (dTypeForm) {
  <div class="flex flex-col w-full h-full">
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
      <div class="text-lg font-medium">{{ $safeNavigationMigration(dTypeForm.dType?.caption) | localize }}</div>
      <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
        <mat-icon class="text-current" svgIcon="feather:x"></mat-icon>
      </button>
    </div>
    <!-- Content -->
    <div class="flex flex-col flex-auto p-6 sm:p-8" fuseScrollbar>
      <dtype-component-list [dtypeForm]="dTypeForm" [isUpdate]="data.update">
      </dtype-component-list>
    </div>
    <!-- Actions -->
    @if (!data.readonly) {
      <div class="flex flex-0 flex-col sm:flex-row gap-2 px-6 py-4 bg-gray-50 dark:bg-black dark:bg-opacity-10">
        @for (action of actions; track action) {
          @if (action.show) {
            <button (click)="actionFn[action.key]()" mat-button [class.mat-raised-button]="action.type === 'raised'"
              [class.mat-stroked-button]="action.type === 'stroked'"
              [class.mat-flat-button]="action.type === 'flat'" [color]="action.color"
              [ngClass]="action.maxMr ? 'sm:mr-auto' : ''">
              {{ action.label }}
            </button>
          }
        }
      </div>
    }
  </div>
} @else {
  <div>no dTypeForm</div>
}

<!-- TODO add styles -->
